import React, {useState} from "react";
import {useSelector} from "react-redux";
import styles from "./index.module.css";
import {Modal, Fab,createStyles, makeStyles, Theme, Tab, Tabs, Box} from "@material-ui/core";
import {AppState} from "../../root/RootReducer";
import EditIcon from "@material-ui/icons/Edit";
import {isAdmin,isPresenter} from "../../user/User";
import EditVideoPage from "./EditVideo";
import EditSurveyModal from "./EditSurvey";
import EditVideoSlideModal from "./EditVideoSlide";
import {Video} from "../../common/video/models/Video";
import OnLeaveDialog from "../../common/components/dialog/OnLeaveDialog";
import useResponsive from "../../common/useResponsive";

interface EditVideoTabProps {
    video: Video;
}

const useStyles = makeStyles(() =>
    createStyles({
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)"
            }
        }
    })
);

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={2}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`
    };
}

function EditVideoTab({video}: EditVideoTabProps) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    // ユーザ入力保存確認

    const [isSaved, setIsSaved] = React.useState<boolean>(true);
    const [newValue, setNewValue] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [isClose, IsClose] = useState(false);

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
    };

    const handleConfirm = () => {
        if(isClose){
            ShowEditVideoModal(false);
            setValue(0);
        }else{
            setValue(newValue);
        }
        setIsSaved(true);
        handleCloseDialog();
    };



    // ビデオ編集モーダル画面表示制御
    const [isOpenEditVideoModal, ShowEditVideoModal] = useState(false);
    const handlePropagation = (event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
    };

    const OpenEditVideoModal = () =>{
        ShowEditVideoModal(true);

    };

    const CloseEditVideoModal = () =>{
        if(isSaved){
            setValue(0);
            ShowEditVideoModal(false);
        }else{
            setOpenDialog(true);
            IsClose(true);
        }
    };

    const ForceCloseEditVideoModal = () => {
        setIsSaved(true);
        setValue(0);
        ShowEditVideoModal(false);
    };

    return (
        <>
            {
                <div className={styles.editIcon} onClick={handlePropagation}>
                    <Fab
                        variant="circular"
                        size="small"
                        onClick={OpenEditVideoModal}
                        className= {classes.icon}
                    >
                        <EditIcon style={{color: "var(--red)"}}/>
                    </Fab>
                </div>

            }
            {/* ビデオ編集モーダル */}
            <Modal
                open={isOpenEditVideoModal}
                onClose={CloseEditVideoModal}
                className={styles.editModal}
            >
                <div className={styles.modalItem}>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={(event, newValue) => {
                            if (isSaved) {
                                setValue(newValue);
                            } else {
                                setOpenDialog(true);
                                setNewValue(newValue);
                                IsClose(false);
                            }
                        }}
                        aria-label="Admin tabs"
                        className={styles.tabs}
                        style={{width: "200px", color: "var(--red)", textTransform: "none"}}
                        textColor="secondary"
                    >
                        <Tab style={{textTransform: "none"}} label="Video編集" {...a11yProps(0)}/>
                        <Tab label="アンケート編集" {...a11yProps(1)}/>
                        <Tab style={{textTransform: "none"}} label="Slide編集" {...a11yProps(2)}/>
                    </Tabs>

                    {/* ビデオ編集 */}
                    <TabPanel value={value} index={0}>
                        <div className={styles.tabItem}>
                            <EditVideoPage
                                videoId={video.id}
                                CloseEditVideoTab={CloseEditVideoModal}
                                isSaved={isSaved}
                                setIsSaved={setIsSaved}
                            />
                        </div>
                    </TabPanel>

                    {/* アンケート編集 */}
                    <TabPanel value={value} index={1}>
                        <div className={styles.tabItem}>
                            <EditSurveyModal
                                videoId={video.id}
                                video={video}
                                CloseEditVideoTab={CloseEditVideoModal}
                                isSaved={isSaved}
                                setIsSaved={setIsSaved}
                                ForceCloseEditVideoModal={ForceCloseEditVideoModal}
                            />
                        </div>
                    </TabPanel>

                    {/* スライド編集 */}
                    <TabPanel value={value} index={2}>
                        <div className={styles.tabItem}>
                            <EditVideoSlideModal
                                videoId={video.id}
                                CloseEditVideoTab={CloseEditVideoModal}
                                video={video}
                                isSaved={isSaved}
                                setIsSaved={setIsSaved}
                                ForceCloseEditVideoModal={ForceCloseEditVideoModal}
                            />
                        </div>
                    </TabPanel>
                </div>
            </Modal>


            {/*------------------------ ユーザ入力保存確認モーダル ------------------------*/}
            <OnLeaveDialog
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </>
    );
}

function EditVideoTabAuth(props:EditVideoTabProps) {
    const {isDesktop} = useResponsive();
    // ユーザー取得
    const userInfo = useSelector((state: AppState) => (state.user.userInfo));
    const showEditVideo  = isDesktop &&
    (isAdmin(userInfo?.roles) || (isPresenter(userInfo?.roles) && props.video.presenterId == userInfo?.id));
    return showEditVideo ? <EditVideoTab {...props}/> : null;
}

export default EditVideoTabAuth;
